import Vue from 'vue'

const AppFilter = {}

AppFilter.install = (Vue) => {
  // number 过滤
  Vue.filter('number', (val, precision = 2) => {
    if (!isNaN(val)) {
      return Number(val).toFixed(precision)
    }
  })
  // 保持两位小数，如果为2.00则显示2
  Vue.filter('cut', (input) => {
    try {
      var originalValue = parseFloat(input)
      var value = input
      if ((value = parseInt(input)) === originalValue) {
        return value
      } else if ((value = originalValue.toFixed(1)) === originalValue) {
        return value
      } else {
        return originalValue.toFixed(2).toString()
      }
    } catch (ex) {
      return input
    }
  })
}

Vue.use(AppFilter)
